//@ts-check
import { useCallback, useEffect, useState } from 'react'
import { assoc, assocPath } from 'ramda'
import { findSubjects } from 'api/v2/subjects'
import { SubLevel } from 'utils/constants'

function makeSubjectLabel(subject) {
  if (subject.subLevels?.includes(SubLevel.INTERNATIONAL))
    return subject.name + ' (Internacional)'
  return subject.name
}

/**
 *
 * @param {{fetchOnMount: boolean}} [options]
 * @returns {{subjects: Array, subjectsById: object, isFetching: boolean, fetchSubjects: ()=>void}}
 */
export default function useSubjects(options) {
  const currentOptions = { fetchOnMount: true, ...(options || {}) }
  const { fetchOnMount } = currentOptions
  const [{ subjects, subjectsById, isFetching }, setState] = useState({
    subjects: [],
    subjectsById: {},
    isFetching: false
  })

  const fetchSubjects = useCallback(() => {
    setState(assoc('isFetching', true))
    findSubjects()
      .then(subjects => {
        setState(state => ({
          ...state,
          subjects: subjects.map(s => {
            s.label = makeSubjectLabel(s)
            s.value = s.id
            return s
          }),
          subjectsById: subjects.reduce(
            (acc, subject) => assocPath([subject.id], subject, acc),
            {}
          ),
          isFetching: false
        }))
      })
      .catch(e => {
        console.error('Error fetching subjects:', e)
        setState(assoc('isFetching', false))
      })
  }, [])

  useEffect(() => {
    fetchOnMount && fetchSubjects()
  }, [fetchOnMount, fetchSubjects])
  return {
    subjects,
    subjectsById,
    isFetching,
    fetchSubjects
  }
}
